import { render, staticRenderFns } from "./Allocate.vue?vue&type=template&id=05db3fc1&"
import script from "./Allocate.vue?vue&type=script&lang=js&"
export * from "./Allocate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports